import { useAuth } from '@clerk/react-router';
import { type ReactNode } from 'react';

import { AppApolloProvider } from '@/apollo/components/AppApolloProvider';

type ClerkApolloProviderProps = {
  children: ReactNode;
};

// Every API request carries the Clerk session token of the active workspace.
export const ClerkApolloProvider = ({ children }: ClerkApolloProviderProps) => {
  const { getToken } = useAuth();

  return (
    <AppApolloProvider getAuthToken={getToken}>{children}</AppApolloProvider>
  );
};
